export const ACTIVITIES_RECIEVED = "ACTIVITIES_RECIEVED"
export const ACTIVITIES_SAVED = "ACTIVITIES_SAVED"
export const ACTIVITIES_DELETED = "ACTIVITIES_DELETED"
export const ACTIVITIES_UNLOADED = "ACTIVITIES_UNLOADED"
